import ToolkitProvider from "react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import React, {useEffect, useState} from "react";
import {Card, Row} from "react-bootstrap";
import offersApi from "../../../../api/offertes";
import GuardWrapper from "../../../../components/guards/GuardWrapper";
import notyf from "../../../../utils/notyfApi";
import OfferServiceFormsModal from "./OfferServiceFormsModal";
import OfferDeleteServiceFormModal from "./OfferDeleteServiceFormModal";
import Loader from "../../../../components/Loader";

export default function OfferServiceForms({id, name, reference}) {
    const columns = [
        {
            dataField: "service_form_id",
            text: "id",
            hidden: true,
        },
        {
            dataField: "service_form_project_name",
            text: "naam",
            formatter: (_c, r) => {
                return <a target="_blank" rel="noreferrer"
                          href={`https://service-formulier.y-con.nl/${r.service_form_id}/overview`}>
                    {r.service_form_project_reference} {r.service_form_project_name}
                </a>
            },
            sort: true,
        },
        {
            text: "acties",
            dataField: "service_form_project_reference",
            formatter: (_c, r) => {
                return <GuardWrapper role={"write:offers"}>
                    <OfferDeleteServiceFormModal id={r.service_form_id} reload={getData}/>
                </GuardWrapper>
            },
            sort: true,
        },
    ];

    const [list, setList] = useState(null);

    useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getData = async () => {
        const res = await offersApi.getAllService(id);
        if (!res.ok) return notyf.error("Error " + res.status)
        setList(res.data);
    };

    if (!list) return <Loader/>;
    return (
        <Card>
            <Card.Header>
                <Card.Title tag="h5" className="mb-0 ">
                    Onderhoudsoffertes
                    <GuardWrapper role={"write:offers"}>
                        <OfferServiceFormsModal id={id} name={name} reference={reference} reload={getData}/>
                    </GuardWrapper>
                </Card.Title>
            </Card.Header>
            <Card.Body>
                {list.length ? <ToolkitProvider
                    keyField="project_form_project_id"
                    data={list}
                    columns={columns}
                    search
                >
                    {(props) => (
                        <div>
                            <BootstrapTable
                                {...props.baseProps}
                                pagination={paginationFactory()}
                            />
                        </div>
                    )}
                </ToolkitProvider> : <Row className="justify-content-center align-self-center w-100 text-center">
                    Er zijn geen projectformulieren gevonden.
                </Row>}
            </Card.Body>
        </Card>
    );
}

